import { render } from "./TwitterIcon.svg?vue&type=template&id=f788f74a"
const script = {}
script.render = render

export default script